import common from './zh-CN/common';
import country from './zh-CN/country';
import explore from './zh-CN/explore';
import login from './zh-CN/login';
import calendar from './zh-CN/calendar';
import feedback from './zh-CN/feedback';
import guide from './zh-CN/guide';
import navHeader from './zh-CN/navHeader';
import studio from './zh-CN/studio';
import urlCollection from './zh-CN/urlCollection';

export default {
  ...common,
  ...country,
  ...explore,
  ...login,
  ...calendar,
  ...feedback,
  ...guide,
  ...navHeader,
  ...studio,
  ...urlCollection,
};
